import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getPreviewRestaurants, getRestaurantBySlug} from 'api/requests';
import {IRestaurantBySlugRequest, IRestaurantResponse} from 'types';

export const useRestaurantBySlug = (
  queryKey: QueryKey,
  query: IRestaurantBySlugRequest,
  options: UseQueryOptions<IRestaurantResponse>,
  locale: string,
  coordinates: string,
  preview?: boolean,
) => {
  return useQuery<IRestaurantResponse>({
    queryKey,
    queryFn: () => {
      if (preview) {
        return getPreviewRestaurants({slug: query?.slug}, locale);
      }
      return getRestaurantBySlug(query, locale, coordinates);
    },
    ...options,
    // TODO://fix this shit code
    enabled: !!query?.slug && query.slug !== 'undefined' && query.slug !== '[slug]', //this required provider
  });
};
